import { render, staticRenderFns } from "./HomeNav.vue?vue&type=template&id=5b2e543a&scoped=true&"
import script from "./HomeNav.vue?vue&type=script&lang=js&"
export * from "./HomeNav.vue?vue&type=script&lang=js&"
import style0 from "./HomeNav.vue?vue&type=style&index=0&id=5b2e543a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e543a",
  null
  
)

export default component.exports